<div class="row">
  <div class="column">
    <div class="ui horizontal list">
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Location</div>
          <div class="menu dropdown-filter" fuiDropdownMenu>
            <ais-hierarchical-menu
              [attributes]="[
                'screenLocation.lvl0',
                'screenLocation.lvl1',
                'screenLocation.lvl2',
                'screenLocation.lvl3'
              ]"
            ></ais-hierarchical-menu>
          </div>
        </div>
      </div>
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Advertising Spot</div>
          <div class="menu dropdown-filter" fuiDropdownMenu>
            <ais-refinement-list
              attribute="locationType"
              [searchable]="false"
            ></ais-refinement-list>
          </div>
        </div>
      </div>
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Categories</div>
          <div class="menu dropdown-filter" fuiDropdownMenu>
            <ais-refinement-list
              attribute="screenCategories"
              [searchable]="false"
            >
            </ais-refinement-list>
          </div>
        </div>
      </div>
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Language</div>
          <div class="menu dropdown-filter" fuiDropdownMenu>
            <ais-refinement-list attribute="languages"> </ais-refinement-list>
          </div>
        </div>
      </div>
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Price</div>
          <div class="dropdown-filter range-slider menu" fuiDropdownMenu>
            <ais-range-slider
              attribute="screenPrice"
              [pips]="false"
              [precision]="2"
            ></ais-range-slider>
          </div>
        </div>
      </div>
      <div class="item">
        <div
          class="ui basic primary pointing dropdown circular button"
          fuiDropdown
          autoClose="disabled"
        >
          <div class="text">Footfall</div>
          <div class="menu dropdown-filter range-slider" fuiDropdownMenu>
            <ais-range-slider
              attribute="monthlyFootfall"
              [pips]="false"
              [precision]="0"
            ></ais-range-slider>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<br />
<div class="ui grid">
  <div class="stretched row">
    <div
      class="sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column"
    >
      <div class="ui secondary no border segment">
        <ais-hits>
          <ng-container> </ng-container>
          <ng-template let-hits="hits" let-results="results">
            <div class="hits-container" *ngIf="hits.length !== 0">
              <div class="ui two column grid">
                <div class="row">
                  <ng-container *ngFor="let hit of hits">
                    <div class="column">
                      <signgaze-listing-item
                        [screenListing]="hit"
                      ></signgaze-listing-item>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>
        </ais-hits>
      </div>
    </div>
    <div
      class="sixteen-wide-mobile sixteen-wide-tablet eight-wide-computer column"
    >
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3680.311376919954!2d75.87168661505146!3d22.71666513339185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fd16565b01b9%3A0xa840986a11c8cc51!2sSilver%20Mall!5e0!3m2!1sen!2sin!4v1614742609011!5m2!1sen!2sin"
        width="100%"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
      ></iframe>
    </div>
  </div>
</div>
